import $, { each } from "jquery";
import { Klass, csl, u_ } from "@pressmedia/webappbase";

const device = Klass("Console").device;

export default {
	/**
	 * 入力値の初期化（全件検索の条件にする）
	 * @returns this
	 */
	clearVal() {
		!!this.$self && this.$self.find(`.${this.inputClassName}`).each((i, elm) => {
			const tag = elm.nodeName.toLowerCase();
			const inpType = elm.type;
			const $inp = $(elm);
			
			if(tag === "input" && inpType === "checkbox") {
				$inp.prop("checked", !this.filterOffMode).trigger("change", [true]);
			} else {
				$inp.val("").trigger("change", [true]);
			}
		});
		
		return this;
	},
	
	/**
	 * 入力値の反映
	 * @param {Object} [valObj]
	 * @returns this
	 */
	setVal(valObj) {
		this.isObject(valObj) || (valObj = {});
		
		// 一旦初期状態へ
		this.clearVal();
		
		const periodPeriods = {};
		const { inputIdPrefix, keywordQuery } = this; 
		Object.keys(valObj).forEach(pk => {
			if(pk === keywordQuery && pk !== "KEYWORD") {
				pk = "KEYWORD";
				valObj[pk] = valObj[keywordQuery];
				delete valObj[keywordQuery];
			}
			
			const $elm = $(`#${inputIdPrefix}_${pk}`);
			let sPi = this.searchParams[pk];
			
			if(!sPi) {
				const tmp = pk.split("_");
				sPi = this.searchParams[ tmp[0] ];
				if(!sPi) {
					return true;
				}
				
				if(sPi.inpType === "period" && tmp.length === 3) {
					!periodPeriods[ tmp[0] ] && (periodPeriods[ tmp[0] ] = {});
					!periodPeriods[ tmp[0] ][ tmp[1] ] && (periodPeriods[ tmp[0] ][ tmp[1] ] = {
						from: false,
						to: false
					});
					
					if(tmp[2] === "from" || tmp[2] === "to") {
						periodPeriods[ tmp[0] ][ tmp[1] ][ tmp[2] ] = true;
					}
				}
			}
			
			const v = valObj[pk];
			
			if($elm.length) {
				switch(sPi.inpType) {
					case "text": {
						$elm.val( v.replace(/\+/g, " ") ).trigger("change", [true]);
						break;
					}
					
					case "number":
					case "date":
					case "datetime":
					case "period": {
						$elm.val(v).trigger("change", [true]);
						break;
					}
					
					case "select": {
						!!v && $elm.val(v).trigger("change", [true]);
						break;
					}
					
					default: {
						csl.warn(`${this.name}.setVal():`, `unkown param '${pk}'`, sPi.inpType);
						break;
					}
				}
				
			} else {
				switch(sPi.inpType) {
					case "flg":
					case "radio":
					case "checkbox": {
						if(!this.filterOffMode) {
							// 一旦全てのチェックを外す
							$(`#area_${inputIdPrefix}_${pk}`).children(".field-inp").each((i, field) => {
								$(field).children(".inp-checkbox").prop("checked", false);
							});
						}
						// 条件指定されているものにチェックを入れる
						v.split(",").forEach(k => {
							$(`#${inputIdPrefix}_${pk}_${k}`).prop("checked", true).trigger("change", [true]);
						});
						break;
					}
					
					default: {
						csl.warn(`${this.name}.setVal():`, `unkown param '${pk}'`, sPi.inpType);
						break;
					}
				}
			}
		});
		
//		csl.log("periodPeriods", periodPeriods);
		Object.keys(periodPeriods).forEach(k => {
			const idArr = [inputIdPrefix, k, "conf"];
			const has = {
				start: !!periodPeriods[k].s,
				end: !!periodPeriods[k].e
			};
			
			if(has.start && has.end) {
				if(!periodPeriods[k].s.from && !periodPeriods[k].e.to) {
					// 期間で検索
					idArr.push("b");
				} else {
					// 詳細検索
					idArr.push("a");
				}
				
			} else
			if(has.start) {
				// 開始日で検索
				idArr.push("s");
			} else {	// === hasEnd: true
				// 終了日で検索
				idArr.push("e");
			}
			
			const $elm = $(`#${idArr.join("_")}`);
			if($elm.length && $elm.prop("checked") === false) {
				$elm.prop("checked", true).trigger("change", [true]);
			}
		});
		
		return this;
	},
	
	/**
	 * 入力値の取得
	 * @returns {Object}
	 */
	getVal() {
		if(!this.$self) {
			return {};
		}
		
		const $fm = this.$self.clone();
		
		// 空のデータを除外
		$fm.find(`.${this.inputClassName}[type='text']`).each((i, elm) => {
			!elm.value && $(elm).remove();
		});
		
		if(device[0] === "sp") {
			$fm.find(`.${this.inputClassName}[type='date']`).each((i, elm) => {
				!elm.value && $(elm).remove();
			});
		}
		
		// checkboxの処理
		$fm.find(".area-checkbox").each((i, elm) => {
			const $elm = $(elm);
			const flg = {
				checked: 0,
				unchecked: 0
			};
			const arr = [];
			
			$elm.children(".field-inp").each((j, field) => {
				const inp = $(field).children(".inp-checkbox").get(0);
				if(inp) {
					flg[inp.checked ? "checked" : "unchecked"]++;
					inp.checked && arr.push(inp.value);
				}
			});
			
			// filterOffMode: trueの場合... チェックがされているものがあれば検索に含める
			// filterOffMode: falseの場合... チェックが外れているものがあれば検索に含める
			flg.filter = this.filterOffMode ? flg.checked : flg.unchecked;
			
			if(flg.filter) {
				// チェックが外れているものがあれば検索に含める
				$elm.empty().append(
					$("<input/>").attr({
						type: "hidden",
						name: $elm.attr("data-name")
					}).val( arr.join(",") )
				);
			} else {
				$elm.remove();
			}
		});
		
		// selectはclone()時にvalueがコピーされない
		$fm.find("select").each((i, elm) => {
			const val = $(`#${elm.id}`).val();
			if(val) {
				$(elm).replaceWith(
					$("<input/>").attr({
						type: "hidden",
						name: elm.name
					}).val(val)
				);
			} else {
				$(elm).remove();
			}
		});
		
		// periodの設定部分を除外
		$fm.find(".period-config").remove();
		
		const valObj = u_.parseQueryString( $fm.serialize() );
		if(
			u_.hasProperty(valObj, "KEYWORD") &&
			this.keywordQuery !== "KEYWORD"
		) {
			valObj[this.keywordQuery] = valObj.KEYWORD;
			delete valObj.KEYWORD;
		}
		
		return valObj;
	},
};
